import {createSelector} from 'reselect';

const selectModal = (state) => state.modal;

const selectGlobalModals = createSelector(selectModal, (modalState) => modalState.globalModals);

export {selectGlobalModals};
